import { Routes, Route } from "react-router-dom";
import RequirePerm from "components/auth/RequirePerm";
import Home from "pages/Home";
import Messages from "pages/Messages";
import MessageDetail from "pages/MessageDetail";
import BrandMaster from "pages/BrandMaster";
import ColorMaster from "pages/ColorMaster";
import SizeGroupingMaster from "pages/SizeGroupingMaster";
import ItemMaster from "pages/ItemMaster";
import SizeMaster from "pages/SizeMaster";
import ShapeMaster from "pages/ShapeMaster";
import UnitMaster from "pages/UnitMaster";
import UomConversion from "pages/UomConversion";
import SubBrandMaster from "pages/SubBrandMaster";
import ItemMasterBulk from "pages/ItemMasterBulk";
import ItemListReport from "pages/ItemListReport";
import EditBulkItemPage from "pages/EditBulkItemPage";
import PackRatio from "pages/PackRatio";
import PricelistMaster from "pages/PricelistMaster";
import PricelistDetail from "pages/PricelistDetail";

import Order from "pages/Order";
import RateOrder from "pages/RateOrder";
import ColumnOrder from "pages/ColumnOrder";
import Cvletter from "pages/Cvletter";
import SetCvletter from "components/cvletter/SetCvletter";
import Salebill from "pages/SaleBill";
import SetSaleBill from "components/saleBill/SetSaleBill";
import CreditDebitNote from "pages/CreditDebitNote";
import SetCreditDebitNote from "components/cndn/SetCreditDebitNote";
import ShippingInfo from "pages/ShippingInfo";
import SetShippingInfo from "components/shippingInfo/SetShippingInfo.jsx";
import DocumentViewer from "pages/DocumentViewer";
import PaymentReconList from "pages/PaymentReconList";
import GLAccountsMaster from "pages/GLAccountsMaster";
import CreateAccountMaster from "pages/CreateAccountMaster";
import EditAccountMaster from "pages/EditAccountMaster";
import OrderPrintGroupMaster from "pages/OrderPrintGroupMaster";
import GroupMaster from "pages/GroupMaster";
import OpeningBalances from "pages/OpeningBalances";
import DiscountMaster from "pages/DiscountMaster";
import ProfilingMaster from "pages/ProfilingMaster";
import CndnTypesMaster from "pages/CndnTypesMaster";
import VoucherMaster from "pages/VoucherMaster";
import SetPaymentRecon from "components/paymentrecon/SetPaymentRecon";
import SchemeGiftItemMaster from "pages/SchemeGiftItemMaster";
import SchemeIssueMaster from "pages/SchemeIssueMaster";
import SchemeMasterPage from "pages/SchemeMasterPage";
import SchemeDetail from "pages/SchemeDetail";
import SchemeDetailSelector from "pages/SchemeDetailSelector";
import SchemeEligibilitySummary from "pages/reports/SchemeEligibilitySummary";
import SchemeEligibilityDetail from "pages/reports/SchemeEligibilityDetail";
import SchemePrint from "pages/reports/SchemePrint";
import SchemePendingOrders from "pages/reports/SchemePendingOrders";
import SchemeOrderRecon from "pages/SchemeOrderRecon";

// Reports
import OrderHistory from "pages/reports/OrderHistory";
import RegisterGenerator from "pages/reports/RegisterGenerator";
import PendingOrders from "pages/reports/PendingOrders";
import OpeningTrail from "pages/reports/OpeningTrail";
import Ledger from "pages/reports/Ledger";
import JournalBook from "pages/reports/JournalBook";
import TrailBalance from "pages/reports/TrailBalance";
import DayBook from "pages/reports/DayBook";
import FinancialStatement from "pages/reports/FinancialStatement";
import AgentSalesAnalytics from "pages/reports/AgentSalesAnalytics";
import PaymentDueAging from "pages/reports/PaymentDueAging";
import AnalysisItems from "pages/reports/AnalysisItems";
import StockReport from "pages/reports/StockReport";
import MailTracker from "pages/MailTracker";
import OrderReconciliation from "pages/OrderReconciliation";
import AreaMaster from "pages/AreaMaster";
import DueReminder from "pages/DueReminder";

export default function AppRoutes() {
  return (
    <Routes>
      <Route path="/" element={<Home />} />

      {/* Raw Item Masters */}
      <Route path="/brandmaster" element={<RequirePerm module="MOD_BRAND"><BrandMaster /></RequirePerm>} />
      <Route path="/subbrandmaster" element={<RequirePerm module="MOD_SUBBRAND"><SubBrandMaster /></RequirePerm>} />
      <Route path="/colormaster" element={<RequirePerm module="MOD_COLOR"><ColorMaster /></RequirePerm>} />
      <Route path="/size-grouping-master" element={<RequirePerm module="MOD_SIZE_GROUP"><SizeGroupingMaster /></RequirePerm>} />
      <Route path="/itemmaster" element={<RequirePerm module="MOD_RAW_ITEM"><ItemMaster /></RequirePerm>} />
      <Route path="/shapemaster" element={<RequirePerm module="MOD_SHAPE"><ShapeMaster /></RequirePerm>} />
      <Route path="/sizemaster" element={<RequirePerm module="MOD_SIZE"><SizeMaster /></RequirePerm>} />
      <Route path="/unitmaster" element={<RequirePerm module="MOD_UNIT"><UnitMaster /></RequirePerm>} />
      <Route path="/uomconversion" element={<RequirePerm module="MOD_UOM_CONV"><UomConversion /></RequirePerm>} />
      <Route path="/cndntypes" element={<RequirePerm module="MOD_CNDN_TYPES"><CndnTypesMaster /></RequirePerm>} />
      <Route path="/areamaster" element={<RequirePerm module="MOD_AREA"><AreaMaster /></RequirePerm>} />

      {/* Main Item Masters */}
      <Route path="/item-master-bulk" element={<RequirePerm module="MOD_ITEM_BULK"><ItemMasterBulk /></RequirePerm>} />
      <Route path="/item-master-bulk/edit/:id" element={<RequirePerm module="MOD_ITEM_BULK"><EditBulkItemPage /></RequirePerm>} />
      <Route path="/packratio" element={<RequirePerm module="MOD_PACK_RATIO"><PackRatio /></RequirePerm>} />
      <Route path="/pricelist" element={<RequirePerm module="MOD_PRICELIST"><PricelistMaster /></RequirePerm>} />
      <Route path="/pricelistdetail" element={<RequirePerm module="MOD_PRICELIST"><PricelistDetail /></RequirePerm>} />
      <Route path="/order-print-group" element={<RequirePerm module="MOD_ORDER_PRINT_GROUP"><OrderPrintGroupMaster /></RequirePerm>} />
      <Route path="/discount-masters" element={<RequirePerm module="MOD_DISCOUNT"><DiscountMaster /></RequirePerm>} />

      {/* Account Masters */}
      <Route path="/groups" element={<RequirePerm module="MOD_PARTY_GROUP"><GroupMaster /></RequirePerm>} />
      <Route path="/gl-accounts-master" element={<RequirePerm module="MOD_GL_ACCOUNTS"><GLAccountsMaster /></RequirePerm>} />
      <Route path="/gl-accounts-master/create" element={<RequirePerm module="MOD_GL_ACCOUNTS"><CreateAccountMaster /></RequirePerm>} />
      <Route path="/gl-accounts-master/edit/:ps_Id" element={<RequirePerm module="MOD_GL_ACCOUNTS"><EditAccountMaster /></RequirePerm>} />
      <Route path="/opening-balances" element={<RequirePerm module="MOD_OPN_BAL"><OpeningBalances /></RequirePerm>} />
      <Route path="/profiling-master" element={<RequirePerm module="MOD_PROFILING"><ProfilingMaster /></RequirePerm>} />

      {/* Inventory */}
      <Route path="/order" element={<RequirePerm module="MOD_ORDER"><Order /></RequirePerm>} />
      <Route path="/rate-order" element={<RequirePerm module="MOD_ORDER"><RateOrder /></RequirePerm>} />
      <Route path="/column-order" element={<RequirePerm module="MOD_ORDER"><ColumnOrder /></RequirePerm>} />
      <Route path="/order-reconciliation" element={<RequirePerm module="MOD_ORDER_RECON"><OrderReconciliation /></RequirePerm>} />
      <Route path="/shippingInfo" element={<RequirePerm module="MOD_SHIPPING"><ShippingInfo /></RequirePerm>} />
      <Route path="/shippinginfo/new" element={<RequirePerm module="MOD_SHIPPING"><SetShippingInfo /></RequirePerm>} />
      <Route path="/shippinginfo/:id" element={<RequirePerm module="MOD_SHIPPING"><SetShippingInfo /></RequirePerm>} />
      <Route path="/salebill" element={<RequirePerm module="MOD_SALEBILL"><Salebill /></RequirePerm>} />
      <Route path="/salebill/new" element={<RequirePerm module="MOD_SALEBILL"><SetSaleBill /></RequirePerm>} />
      <Route path="/salebill/:id" element={<RequirePerm module="MOD_SALEBILL"><SetSaleBill /></RequirePerm>} />
      <Route path="/cndn" element={<RequirePerm module="MOD_CNDN"><CreditDebitNote /></RequirePerm>} />
      <Route path="/cndn/new" element={<RequirePerm module="MOD_CNDN"><SetCreditDebitNote /></RequirePerm>} />
      <Route path="/cndn/:id" element={<RequirePerm module="MOD_CNDN"><SetCreditDebitNote /></RequirePerm>} />

      {/* Accounts */}
      <Route path="/voucher-master" element={<RequirePerm module="MOD_VOUCHER"><VoucherMaster /></RequirePerm>} />
      <Route path="/cvletter" element={<RequirePerm module="MOD_CV_LETTER"><Cvletter /></RequirePerm>} />
      <Route path="/cvletter/new" element={<RequirePerm module="MOD_CV_LETTER"><SetCvletter /></RequirePerm>} />
      <Route path="/cvletter/:id" element={<RequirePerm module="MOD_CV_LETTER"><SetCvletter /></RequirePerm>} />
      <Route path="/paymentrecon" element={<RequirePerm module="MOD_PAYMENT_RECON"><PaymentReconList /></RequirePerm>} />
      <Route path="/paymentrecon/new" element={<RequirePerm module="MOD_PAYMENT_RECON"><SetPaymentRecon /></RequirePerm>} />
      <Route path="/paymentrecon/:id" element={<RequirePerm module="MOD_PAYMENT_RECON"><SetPaymentRecon /></RequirePerm>} />
      <Route path="/due-reminder" element={<RequirePerm module="MOD_DUE_REMINDER"><DueReminder /></RequirePerm>} />

      {/* Reports - Inventory */}
      <Route path="/reports/inventory/item-list" element={<RequirePerm module="MOD_REP_INV_ITEM_LIST"><ItemListReport /></RequirePerm>} />
      <Route path="/reports/inventory/stock" element={<RequirePerm module="MOD_REP_INV_ITEM_LIST"><StockReport /></RequirePerm>} />
      <Route path="/reports/inventory/order-history" element={<RequirePerm module="MOD_REP_INV_ORDER_HIST"><OrderHistory /></RequirePerm>} />
      <Route path="/reports/inventory/order-register" element={<RequirePerm module="MOD_REP_INV_ORDER_REG"><RegisterGenerator /></RequirePerm>} />
      <Route path="/reports/inventory/pending-order" element={<RequirePerm module="MOD_REP_INV_PEND_ORDER"><PendingOrders /></RequirePerm>} />
      <Route path="/reports/inventory/salebill-register" element={<RequirePerm module="MOD_REP_INV_BILL_REG"><RegisterGenerator /></RequirePerm>} />
      <Route path="/reports/inventory/debit-note-register" element={<RequirePerm module="MOD_REP_INV_DN_REG"><RegisterGenerator /></RequirePerm>} />
      <Route path="/reports/inventory/credit-note-register" element={<RequirePerm module="MOD_REP_INV_CN_REG"><RegisterGenerator /></RequirePerm>} />

      {/* Reports - Accounts */}
      <Route path="/reports/accounts/opening-trail" element={<RequirePerm module="MOD_REP_ACC_OPN_TRAIL"><OpeningTrail /></RequirePerm>} />
      <Route path="/reports/accounts/day-book" element={<RequirePerm module="MOD_REP_ACC_DAY_BOOK"><DayBook /></RequirePerm>} />
      <Route path="/reports/accounts/journal-book" element={<RequirePerm module="MOD_REP_ACC_JRNL"><JournalBook /></RequirePerm>} />
      <Route path="/reports/accounts/ledger" element={<RequirePerm module="MOD_REP_ACC_LEDGER"><Ledger /></RequirePerm>} />
      <Route path="/reports/accounts/trail-balance" element={<RequirePerm module="MOD_REP_ACC_TRAIL_BAL"><TrailBalance /></RequirePerm>} />
      <Route path="/reports/accounts/balance-sheet" element={<RequirePerm module="MOD_REP_ACC_BAL_SHEET"><FinancialStatement statementType="balanceSheet" /></RequirePerm>} />
      <Route path="/reports/accounts/profit-loss" element={<RequirePerm module="MOD_REP_ACC_PROFIT_LOSS"><FinancialStatement statementType="profitLoss" /></RequirePerm>} />
      <Route path="/reports/accounts/cash-bank-book" element={<RequirePerm module="MOD_REP_ACC_LEDGER"><Ledger /></RequirePerm>} />
      <Route path="/reports/accounts/payment-due-aging" element={<RequirePerm module="MOD_REP_ACC_AGING"><PaymentDueAging /></RequirePerm>} />
      <Route path="/reports/accounts/analysis-items" element={<RequirePerm module="MOD_REP_ACC_ANALYSIS"><AnalysisItems /></RequirePerm>} />

      {/* Reports - Sales */}
      <Route path="/reports/sales/agent-sales-analytics" element={<RequirePerm module="MOD_REP_SALES"><AgentSalesAnalytics /></RequirePerm>} />

      {/* Scheme */}
      <Route path="/scheme-gift-items" element={<RequirePerm module="MOD_SCH_GIFT"><SchemeGiftItemMaster /></RequirePerm>} />
      <Route path="/scheme-master" element={<RequirePerm module="MOD_SCH_MASTER"><SchemeMasterPage /></RequirePerm>} />
      <Route path="/scheme-detail" element={<RequirePerm module="MOD_SCH_DETAIL"><SchemeDetail /></RequirePerm>} />
      <Route path="/scheme-detail-edit" element={<RequirePerm module="MOD_SCH_DETAIL"><SchemeDetailSelector /></RequirePerm>} />
      <Route path="/scheme-detail/edit/:id" element={<RequirePerm module="MOD_SCH_DETAIL"><SchemeDetail /></RequirePerm>} />
      <Route path="/scheme-issue" element={<RequirePerm module="MOD_SCH_ISSUE"><SchemeIssueMaster /></RequirePerm>} />
      <Route path="/scheme-order-recon" element={<RequirePerm module="MOD_SCH_ORDER_RECON"><SchemeOrderRecon /></RequirePerm>} />

      {/* Scheme Reports */}
      <Route path="/reports/scheme/eligibility-summary" element={<RequirePerm module="MOD_REP_SCH_ELIG_SUM"><SchemeEligibilitySummary /></RequirePerm>} />
      <Route path="/reports/scheme/eligibility-detail" element={<RequirePerm module="MOD_REP_SCH_ELIG_DTL"><SchemeEligibilityDetail /></RequirePerm>} />
      <Route path="/reports/scheme/print" element={<RequirePerm module="MOD_REP_SCH_PRINT"><SchemePrint /></RequirePerm>} />
      <Route path="/reports/scheme/pending-orders" element={<RequirePerm module="MOD_REP_SCH_PEND"><SchemePendingOrders /></RequirePerm>} />

      {/* Plus / Misc */}
      <Route path="/document-viewer/:id" element={<RequirePerm module="MOD_DOC_VIEWER"><DocumentViewer /></RequirePerm>} />
      <Route path="/mail-tracker" element={<RequirePerm module="MOD_MAIL_TRACKER"><MailTracker /></RequirePerm>} />
      <Route path="/messages" element={<Messages />} />
      <Route path="/messages/:id" element={<MessageDetail />} />
      <Route path="/messages/compose" element={<Messages />} />
    </Routes>
  );
}
